import { ControlProperty, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { HubBrief } from './hub.model';
import { Validators } from '@angular/forms';
import { ListQueryParam } from '../../../../../common/constants';
import { DriverIdType } from '../constants';
import { mustNotBeBlankValidator } from '../../../../../common/utils';

export interface Resource {
  id: number;
  uuid: string;
  name: string;
  link: string;
  contentType: string;
  _content?: string | ArrayBuffer;
}

export interface Carrier {
  id: number;
  // eslint-disable-next-line id-blacklist
  number: string;
  name: string;
  extId: string;
}

export class HubFrequentDriverModel {
  id?: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  carrierExtId: string;
  carrierName: string;
  carrierNumber: string;
  permitType: DriverIdType;
  hub: HubBrief;
  permitNumber?: string;
  carrierId?: number;
  creationDateTime?: string;
  createdBy?: number;
  modificationDateTime?: string;
  modifiedBy?: string;
  initialSignatureId?: string;
  lastSignatureId: string;
  organizationId: number;
}

export class HubFrequentDriverListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: HubFrequentDriverListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class HubFrequentDriverSearchCriteria {
  firstName?: string;
  lastName?: string;
  permitNumber?: number;
  permitType?: DriverIdType;
  limit?: number;
  phoneNumber?: string;
  carrierExtId?: string;

  constructor(params?: HubFrequentDriverListSearchCriteria) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class HubFrequentDriverForm {
  constructor(
    model: HubFrequentDriverModel,
    public id: ControlProperty<number> = model.id,
    public firstName: ControlProperty<string> = [model.firstName, [Validators.required, mustNotBeBlankValidator]],
    public lastName: ControlProperty<string> = [model.lastName, [Validators.required, mustNotBeBlankValidator]],
    public carrierExtId: ControlProperty<string> = model.carrierExtId,
    public carrierName: ControlProperty<string> = model.carrierName,
    public carrierNumber: ControlProperty<string> = model.carrierNumber,
    public permitType: ControlProperty<string> = model.permitType,
    public permitNumber: ControlProperty<string> = [model.permitNumber, mustNotBeBlankValidator],
    public phoneNumber: ControlProperty<string> = model.phoneNumber,
    public creationDateTime: ControlProperty<string> = model.creationDateTime,
    public modificationDateTime: ControlProperty<string> = model.modificationDateTime,
  ) {}
}
